import http from "./http";
export const baseUrl = "/v2/api/app";
export const baseUrl2 = "/v2/api/system";
export const uploadDemoBaseUrl = "https://developer-upload.kaihong.com/v2/api/app";
const hostname = window.location.hostname;
const isDeveloper = hostname === "developer.kaihong.com";
export const uploadBaseUrl = isDeveloper ? uploadDemoBaseUrl : baseUrl;

const { get, post } = http;
const getAtomicDetail = (params: any) => post(`${baseUrl}/atomic/detail`, params); // 查询原子化详情
const getAppDetail = (params: any) => post(`${baseUrl}/app/detail`, params); // 查询应用详情
const getEngineDetail = (params: any) => post(`${baseUrl}/engine/detail`, params); // 查询开鸿应用引擎详情
const getAcsDetail = (params: any) => post(`${baseUrl}/acs/detail`, params); // 查询安卓生态应用详情
const getComponentDetail = (params: any) => post(`${baseUrl}/component/detail`, params); // 查询组件详情
const atomicSave = (params: any) => post(`${baseUrl}/atomic/save`, params); // 保存原子化全部信息
const appSave = (params: any) => post(`${baseUrl}/app/save`, params); // 保存应用全部信息
const engineSave = (params: any) => post(`${baseUrl}/engine/save`, params); // 保存开鸿应用引擎全部信息
const acsSave = (params: any) => post(`${baseUrl}/acs/save`, params); // 保存安卓生态应用全部信息
const componentSave = (params: any) => post(`${baseUrl}/component/save`, params); // 保存组件全部信息
const atomicDelete = (params: any) => post(`${baseUrl}/atomic/delete`, params); //删除原子化服务
const appDelete = (params: any) => post(`${baseUrl}/app/delete`, params); //删除应用
const engineDelete = (params: any) => post(`${baseUrl}/engine/delete`, params); //删除开鸿应用引擎
const acsDelete = (params: any) => post(`${baseUrl}/acs/delete`, params); //删除安卓生态应用
const componentDelete = (params: any) => post(`${baseUrl}/component/delete`, params); //删除组件
const atomicAuditRelease = (params: any) => post(`${baseUrl}/atomic/audit/release`, params); //原子化审核上架
const appAuditRelease = (params: any) => post(`${baseUrl}/app/audit/release`, params); //应用审核上架
const engineAuditRelease = (params: any) => post(`${baseUrl}/engine/audit/release`, params); //开鸿应用引擎审核上架
const acsAuditRelease = (params: any) => post(`${baseUrl}/acs/audit/release`, params); //安卓生态应用审核上架
const componentAuditRelease = (params: any) => post(`${baseUrl}/component/audit/release`, params); //组件审核上架
const atomicNextSave = (params: any) => post(`${baseUrl}/atomic/next/save`, params); //原子化保存全部信息并且下一步
const appNextSave = (params: any) => post(`${baseUrl}/app/next/save`, params); //应用保存全部信息并且下一步
const engineNextSave = (params: any) => post(`${baseUrl}/engine/next/save`, params); //开鸿应用引擎保存全部信息并且下一步
const acsNextSave = (params: any) => post(`${baseUrl}/acs/next/save`, params); //安卓生态应用保存全部信息并且下一步
const componentNextSave = (params: any) => post(`${baseUrl}/component/next/save`, params); //组件保存全部信息并且下一步
const atomicCancelRelease = (params: any) => post(`${baseUrl}/atomic/cancel/release`, params); //原子化撤销上架
const appCancelRelease = (params: any) => post(`${baseUrl}/app/cancel/release`, params); //应用撤销上架
const engineCancelRelease = (params: any) => post(`${baseUrl}/engine/cancel/release`, params); //开鸿应用引擎撤销上架
const acsCancelRelease = (params: any) => post(`${baseUrl}/acs/cancel/release`, params); //安卓生态应用撤销上架
const componentCancelRelease = (params: any) => post(`${baseUrl}/component/cancel/release`, params); //组件撤销上架
const atomicAuditDown = (params: any) => post(`${baseUrl}/atomic/audit/down`, params); //原子化审核下架
const appAuditDown = (params: any) => post(`${baseUrl}/app/audit/down`, params); //应用审核下架
const engineAuditDown = (params: any) => post(`${baseUrl}/engine/audit/down`, params); //开鸿应用引擎审核下架
const acsAuditDown = (params: any) => post(`${baseUrl}/acs/audit/down`, params); //安卓生态应用审核下架
const componentAuditDown = (params: any) => post(`${baseUrl}/component/audit/down`, params); //组件审核下架
const atomicCancelDown = (params: any) => post(`${baseUrl}/atomic/cancel/down`, params); //原子化撤销下架
const appCancelDown = (params: any) => post(`${baseUrl}/app/cancel/down`, params); //应用撤销下架
const engineCancelDown = (params: any) => post(`${baseUrl}/engine/cancel/down`, params); //开鸿应用引擎撤销下架
const acsCancelDown = (params: any) => post(`${baseUrl}/acs/cancel/down`, params); //安卓生态应用撤销下架
const componentCancelDown = (params: any) => post(`${baseUrl}/component/cancel/down`, params); //组件撤销下架
const atomicUpgrade = (params: any) => post(`${baseUrl}/atomic/version/upgrade`, params); //原子化服务升级
const appUpgrade = (params: any) => post(`${baseUrl}/app/version/upgrade`, params); //应用服务升级
const engineUpgrade = (params: any) => post(`${baseUrl}/engine/version/upgrade`, params); //开鸿应用引擎服务升级
const acsUpgrade = (params: any) => post(`${baseUrl}/acs/version/upgrade`, params); //安卓生态应用服务升级
const componentUpgrade = (params: any) => post(`${baseUrl}/component/version/upgrade`, params); //组件服务升级
const atomicAuditUpgrade = (params: any) => post(`${baseUrl}/atomic/audit/upgrade`, params); //原子化审核升级
const appAuditUpgrade = (params: any) => post(`${baseUrl}/app/audit/upgrade`, params); //应用审核升级
const engineAuditUpgrade = (params: any) => post(`${baseUrl}/engine/audit/upgrade`, params); //开鸿应用引擎审核升级
const acsAuditUpgrade = (params: any) => post(`${baseUrl}/acs/audit/upgrade`, params); //安卓生态应用审核升级
const componentAuditUpgrade = (params: any) => post(`${baseUrl}/component/audit/upgrade`, params); //组件审核升级
const atomicCancelUpgrade = (params: any) => post(`${baseUrl}/atomic/cancel/upgrade`, params); //原子化撤销升级
const appCancelUpgrade = (params: any) => post(`${baseUrl}/app/cancel/upgrade`, params); //应用撤销升级
const engineCancelUpgrade = (params: any) => post(`${baseUrl}/engine/cancel/upgrade`, params); //开鸿应用引擎撤销升级
const acsCancelUpgrade = (params: any) => post(`${baseUrl}/acs/cancel/upgrade`, params); //安卓生态应用撤销升级
const componentCancelUpgrade = (params: any) => post(`${baseUrl}/component/cancel/upgrade`, params); //组件撤销升级

const componentOs = (params?: any) => post(`${baseUrl}/component/os/page`, params); //查询OS的兼容版本列表

const uploadFile = (params: any, id: string | number, config?: any) =>
  post(`${uploadBaseUrl}/app/upload/public/${id}`, params, config); //上传

const getDict = (params: any) => get(`${baseUrl2}/dict/data/type/${params}`); // 获取字典

export default {
  getAtomicDetail,
  getAppDetail,
  getEngineDetail,
  getAcsDetail,
  getComponentDetail,
  getDict,
  atomicSave,
  appSave,
  engineSave,
  acsSave,
  componentSave,
  atomicDelete,
  appDelete,
  engineDelete,
  acsDelete,
  componentDelete,
  atomicAuditRelease,
  appAuditRelease,
  engineAuditRelease,
  acsAuditRelease,
  componentAuditRelease,
  uploadFile,
  atomicNextSave,
  appNextSave,
  engineNextSave,
  acsNextSave,
  componentNextSave,
  atomicCancelRelease,
  appCancelRelease,
  engineCancelRelease,
  acsCancelRelease,
  componentCancelRelease,
  atomicAuditDown,
  appAuditDown,
  engineAuditDown,
  acsAuditDown,
  componentAuditDown,
  atomicCancelDown,
  appCancelDown,
  engineCancelDown,
  acsCancelDown,
  componentCancelDown,
  atomicUpgrade,
  appUpgrade,
  engineUpgrade,
  acsUpgrade,
  componentUpgrade,
  atomicAuditUpgrade,
  appAuditUpgrade,
  engineAuditUpgrade,
  acsAuditUpgrade,
  componentAuditUpgrade,
  atomicCancelUpgrade,
  appCancelUpgrade,
  engineCancelUpgrade,
  acsCancelUpgrade,
  componentCancelUpgrade,
  componentOs,
};
